import { NgFor, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AgeClass, Event } from '@tanzspass/shared';
import { AgeClassService } from '../../services/age-class.service';
import { EventService } from '../../services/event.service';
import { SchoolService } from '../../services/school.service';

@Component({
  selector: 'ts-event-next',
  templateUrl: './event-next.component.html',
  styleUrls: ['./event-next.component.css'],
  imports: [NgIf, NgFor, RouterLink],
})
export class EventNextComponent implements OnInit {
  public events: Event[] = [];
  public ageClasses: AgeClass[] = [];

  public newsCount = 3;

  constructor(
    private eventSrv: EventService,
    private schoolSrv: SchoolService,
    private ageClassSrv: AgeClassService,
  ) {}

  ngOnInit() {
    this.ageClassSrv.frontPage().subscribe((ageClasses) => {
      this.ageClasses = ageClasses;
      this.schoolSrv.current().subscribe((school) => {
        this.eventSrv.last(school.id, this.newsCount).subscribe((events) => {
          this.events = events;
        });
      });
    });
  }
}
